import * as React from "react";
import styled from "react-emotion";
import { small } from "../theme/typefaces";
import { greyColors } from "../theme/colors";
import { spacing } from "../theme/layout";
const LoaderContainer = styled("div") `
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto; /* Centering in flex containers */
`;
const SpinnerContainer = styled("div") `
  border: 3px solid currentColor;
  border-radius: 100%;
  opacity: 0;

  animation: pulsate 1s ease-out;
  animation-iteration-count: infinite;

  @keyframes pulsate {
    0% {
      transform: scale(0.1);
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      transform: scale(1);
      opacity: 0;
    }
  }
`;
const LabelContainer = styled("p") `
  ${spacing.mt2};
  ${spacing.mb0};
  ${small};
  text-align: center;
  max-width: 300px;
`;
export const Loader = ({ size = 40, color = greyColors["300"], label }) => (<LoaderContainer style={{ color }}>
    <SpinnerContainer style={{
    width: size,
    height: size
}}/>
    {label && <LabelContainer>{label}</LabelContainer>}
  </LoaderContainer>);



// WEBPACK FOOTER //
// ./src/components/Loader.tsx